import request from '@/request';

export default {
 
  331577: () => {
    return request.ticket({
      url: '/gateway/gtgj/act',
      auth:'yes',
      method:'POST',
      data: Object.assign({
        pid: 331577
      }),
      sidFields: ['uid', 'pid']
    })
  }
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/service/freeGoldVIP.js